"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobilePhoneNumberValid = exports.prettifyPhoneNumber = exports.sanitisePhoneNumber = exports.stripPhoneNumberLeadingZeros = exports.stripIcelandicPhonenumberCountryCode = void 0;
var Regex_1 = require("./Regex");
var StringUtils_1 = require("./StringUtils");
var stripIcelandicPhonenumberCountryCode = function (phoneNumber) {
    return phoneNumber.replace(Regex_1.RegexConstants.NotIcelandicPhoneNrCode, '');
};
exports.stripIcelandicPhonenumberCountryCode = stripIcelandicPhonenumberCountryCode;
var stripPhoneNumberLeadingZeros = function (phoneNumber) {
    return phoneNumber.replace(Regex_1.RegexConstants.NotLeadingZeros, '');
};
exports.stripPhoneNumberLeadingZeros = stripPhoneNumberLeadingZeros;
var sanitisePhoneNumber = function (phoneNumber) {
    return (0, exports.stripIcelandicPhonenumberCountryCode)((0, exports.stripPhoneNumberLeadingZeros)((0, StringUtils_1.stripCharacter)(phoneNumber)));
};
exports.sanitisePhoneNumber = sanitisePhoneNumber;
var prettifyPhoneNumber = function (phoneNumber) {
    var phoneNumberSanitised = (0, exports.sanitisePhoneNumber)(phoneNumber);
    if (phoneNumberSanitised.length <= 3)
        return phoneNumberSanitised;
    return "".concat(phoneNumberSanitised.substr(0, 3), "-").concat(phoneNumberSanitised.substr(3));
};
exports.prettifyPhoneNumber = prettifyPhoneNumber;
var isMobilePhoneNumberValid = function (phoneNumber) {
    return Regex_1.RegexConstants.IcelandicMobilePhoneNr.test(phoneNumber);
};
exports.isMobilePhoneNumberValid = isMobilePhoneNumberValid;
//# sourceMappingURL=PhoneNumber.js.map